const BOTTOM_SHEET_ANIMATED_DIV_ID = 'BottomSheetAnimated';

/**
 * Returns a div for the bottom sheet to be present
 */
export function getBottomSheetAnimatedDiv(id?: string): HTMLElement | null {
    let thisBottomSheetAnimatedDiv = getExistingBottomSheetAnimatedDiv(id);

    if (!thisBottomSheetAnimatedDiv) {
        thisBottomSheetAnimatedDiv = document.createElement('div');
        thisBottomSheetAnimatedDiv.id = getBottomSheetAnimatedDivId(id);
        document.body.appendChild(thisBottomSheetAnimatedDiv);
    }

    return thisBottomSheetAnimatedDiv;
}

/**
 * Makes the global bottom sheet object null if present
 */
export function purgeBottomSheetAnimatedDiv(id?: string) {
    const thisBottomSheetAnimatedDiv = getExistingBottomSheetAnimatedDiv(id);

    if (thisBottomSheetAnimatedDiv) {
        document.body.removeChild(thisBottomSheetAnimatedDiv);
    }
}

export function isBottomSheetAnimatedOpen(id?: string, doc: Document = document): boolean {
    return !!doc && !!doc.getElementById(getBottomSheetAnimatedDivId(id));
}

export function getBottomSheetAnimatedDivId(id?: string): string {
    return BOTTOM_SHEET_ANIMATED_DIV_ID + (id || '');
}

function getExistingBottomSheetAnimatedDiv(id: string): HTMLElement {
    return document.getElementById(getBottomSheetAnimatedDivId(id));
}
